// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDispositiveProvisionsMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEntityInput;
}>;


export type CreateDispositiveProvisionsMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string } };

export type CreateDispositiveProvisionsAndAckSuggestionsV2MutationVariables = Types.Exact<{
  entityInput: Types.AugmentedUpdateEntityInput;
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type CreateDispositiveProvisionsAndAckSuggestionsV2Mutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string }, acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export type CreateDispositiveProvisionsForTestamentaryEntitiesMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTestamentaryEntityInput;
}>;


export type CreateDispositiveProvisionsForTestamentaryEntitiesMutation = { __typename?: 'Mutation', updateTestamentaryEntity: { __typename?: 'TestamentaryEntity', id: string } };

export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationVariables = Types.Exact<{
  testamentaryEntityInput: Types.AugmentedUpdateTestamentaryEntityInput;
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation = { __typename?: 'Mutation', updateTestamentaryEntity: { __typename?: 'TestamentaryEntity', id: string }, acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export type CreateDispositiveProvisionsForClientProfileMutationVariables = Types.Exact<{
  input: Array<Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>> | Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>;
}>;


export type CreateDispositiveProvisionsForClientProfileMutation = { __typename?: 'Mutation', updateHouseholds: Array<{ __typename?: 'Household', id: string } | null> };

export const Operations = {
  Mutation: {
    CreateDispositiveProvisions: 'CreateDispositiveProvisions' as const,
    CreateDispositiveProvisionsAndAckSuggestionsV2: 'CreateDispositiveProvisionsAndAckSuggestionsV2' as const,
    CreateDispositiveProvisionsForTestamentaryEntities: 'CreateDispositiveProvisionsForTestamentaryEntities' as const,
    CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntities: 'CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntities' as const,
    CreateDispositiveProvisionsForClientProfile: 'CreateDispositiveProvisionsForClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateDispositiveProvisionsDocument = gql`
    mutation CreateDispositiveProvisions($input: AugmentedUpdateEntityInput!) {
  updateEntity(input: $input) {
    id
  }
}
    `;
export type CreateDispositiveProvisionsMutationFn = Apollo.MutationFunction<CreateDispositiveProvisionsMutation, CreateDispositiveProvisionsMutationVariables>;

/**
 * __useCreateDispositiveProvisionsMutation__
 *
 * To run a mutation, you first call `useCreateDispositiveProvisionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositiveProvisionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositiveProvisionsMutation, { data, loading, error }] = useCreateDispositiveProvisionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDispositiveProvisionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositiveProvisionsMutation, CreateDispositiveProvisionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositiveProvisionsMutation, CreateDispositiveProvisionsMutationVariables>(CreateDispositiveProvisionsDocument, options);
      }
export type CreateDispositiveProvisionsMutationHookResult = ReturnType<typeof useCreateDispositiveProvisionsMutation>;
export type CreateDispositiveProvisionsMutationResult = Apollo.MutationResult<CreateDispositiveProvisionsMutation>;
export type CreateDispositiveProvisionsMutationOptions = Apollo.BaseMutationOptions<CreateDispositiveProvisionsMutation, CreateDispositiveProvisionsMutationVariables>;
export const CreateDispositiveProvisionsAndAckSuggestionsV2Document = gql`
    mutation CreateDispositiveProvisionsAndAckSuggestionsV2($entityInput: AugmentedUpdateEntityInput!, $acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!) {
  updateEntity(input: $entityInput) {
    id
  }
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
}
    `;
export type CreateDispositiveProvisionsAndAckSuggestionsV2MutationFn = Apollo.MutationFunction<CreateDispositiveProvisionsAndAckSuggestionsV2Mutation, CreateDispositiveProvisionsAndAckSuggestionsV2MutationVariables>;

/**
 * __useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation__
 *
 * To run a mutation, you first call `useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositiveProvisionsAndAckSuggestionsV2Mutation, { data, loading, error }] = useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation({
 *   variables: {
 *      entityInput: // value for 'entityInput'
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *   },
 * });
 */
export function useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositiveProvisionsAndAckSuggestionsV2Mutation, CreateDispositiveProvisionsAndAckSuggestionsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositiveProvisionsAndAckSuggestionsV2Mutation, CreateDispositiveProvisionsAndAckSuggestionsV2MutationVariables>(CreateDispositiveProvisionsAndAckSuggestionsV2Document, options);
      }
export type CreateDispositiveProvisionsAndAckSuggestionsV2MutationHookResult = ReturnType<typeof useCreateDispositiveProvisionsAndAckSuggestionsV2Mutation>;
export type CreateDispositiveProvisionsAndAckSuggestionsV2MutationResult = Apollo.MutationResult<CreateDispositiveProvisionsAndAckSuggestionsV2Mutation>;
export type CreateDispositiveProvisionsAndAckSuggestionsV2MutationOptions = Apollo.BaseMutationOptions<CreateDispositiveProvisionsAndAckSuggestionsV2Mutation, CreateDispositiveProvisionsAndAckSuggestionsV2MutationVariables>;
export const CreateDispositiveProvisionsForTestamentaryEntitiesDocument = gql`
    mutation CreateDispositiveProvisionsForTestamentaryEntities($input: AugmentedUpdateTestamentaryEntityInput!) {
  updateTestamentaryEntity(input: $input) {
    id
  }
}
    `;
export type CreateDispositiveProvisionsForTestamentaryEntitiesMutationFn = Apollo.MutationFunction<CreateDispositiveProvisionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsForTestamentaryEntitiesMutationVariables>;

/**
 * __useCreateDispositiveProvisionsForTestamentaryEntitiesMutation__
 *
 * To run a mutation, you first call `useCreateDispositiveProvisionsForTestamentaryEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositiveProvisionsForTestamentaryEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositiveProvisionsForTestamentaryEntitiesMutation, { data, loading, error }] = useCreateDispositiveProvisionsForTestamentaryEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDispositiveProvisionsForTestamentaryEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositiveProvisionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsForTestamentaryEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositiveProvisionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsForTestamentaryEntitiesMutationVariables>(CreateDispositiveProvisionsForTestamentaryEntitiesDocument, options);
      }
export type CreateDispositiveProvisionsForTestamentaryEntitiesMutationHookResult = ReturnType<typeof useCreateDispositiveProvisionsForTestamentaryEntitiesMutation>;
export type CreateDispositiveProvisionsForTestamentaryEntitiesMutationResult = Apollo.MutationResult<CreateDispositiveProvisionsForTestamentaryEntitiesMutation>;
export type CreateDispositiveProvisionsForTestamentaryEntitiesMutationOptions = Apollo.BaseMutationOptions<CreateDispositiveProvisionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsForTestamentaryEntitiesMutationVariables>;
export const CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesDocument = gql`
    mutation CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntities($testamentaryEntityInput: AugmentedUpdateTestamentaryEntityInput!, $acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!) {
  updateTestamentaryEntity(input: $testamentaryEntityInput) {
    id
  }
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
}
    `;
export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationFn = Apollo.MutationFunction<CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationVariables>;

/**
 * __useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation__
 *
 * To run a mutation, you first call `useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation, { data, loading, error }] = useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation({
 *   variables: {
 *      testamentaryEntityInput: // value for 'testamentaryEntityInput'
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *   },
 * });
 */
export function useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationVariables>(CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesDocument, options);
      }
export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationHookResult = ReturnType<typeof useCreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation>;
export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationResult = Apollo.MutationResult<CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation>;
export type CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationOptions = Apollo.BaseMutationOptions<CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutation, CreateDispositiveProvisionsAndAckSuggestionsForTestamentaryEntitiesMutationVariables>;
export const CreateDispositiveProvisionsForClientProfileDocument = gql`
    mutation CreateDispositiveProvisionsForClientProfile($input: [AugmentedUpdateHouseholdInput]!) {
  updateHouseholds(inputs: $input) {
    id
  }
}
    `;
export type CreateDispositiveProvisionsForClientProfileMutationFn = Apollo.MutationFunction<CreateDispositiveProvisionsForClientProfileMutation, CreateDispositiveProvisionsForClientProfileMutationVariables>;

/**
 * __useCreateDispositiveProvisionsForClientProfileMutation__
 *
 * To run a mutation, you first call `useCreateDispositiveProvisionsForClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositiveProvisionsForClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositiveProvisionsForClientProfileMutation, { data, loading, error }] = useCreateDispositiveProvisionsForClientProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDispositiveProvisionsForClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositiveProvisionsForClientProfileMutation, CreateDispositiveProvisionsForClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositiveProvisionsForClientProfileMutation, CreateDispositiveProvisionsForClientProfileMutationVariables>(CreateDispositiveProvisionsForClientProfileDocument, options);
      }
export type CreateDispositiveProvisionsForClientProfileMutationHookResult = ReturnType<typeof useCreateDispositiveProvisionsForClientProfileMutation>;
export type CreateDispositiveProvisionsForClientProfileMutationResult = Apollo.MutationResult<CreateDispositiveProvisionsForClientProfileMutation>;
export type CreateDispositiveProvisionsForClientProfileMutationOptions = Apollo.BaseMutationOptions<CreateDispositiveProvisionsForClientProfileMutation, CreateDispositiveProvisionsForClientProfileMutationVariables>;